module.exports = __webpack_public_path__ + "static/media/jun2.aa03f1fb.jpg";